import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import {
    OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
    , ORFButton as Button
} from '../../../../../common/forms/order-request-form.component';
import { wirelessPortInActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer";
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import CustomSearchableSelectWrapper from "../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import { createRequestActions } from "../../../../../../store/external/request-reducer/create-request.reducer";

class PortInLocationFormA extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if(this.props.wirelessPortInLocationFormA.locationId !== -1)
        {
            this.props.disableAutoScroll(true);
        } else {
            this.props.disableAutoScroll(false);
        }         
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleNextAction = () =>{
        this.props.disableAutoScroll(false);
        this.props.nextAction();
    }
    handleChange = (field, value) =>{
        if(value !== -1){
            this.props.disableAutoScroll(true);
        } else{
            this.props.disableAutoScroll(false);
        } 
        this.props.onAddressSelect(field, value);
    }
    render() {
        const {
            //component props
            nextAction, onClickCancel
            // form
            , wirelessPortInLocationFormA
            // reducer action
            , setRequestorAddress
            , onCountrySelect
            , onAddressSelect
        } = this.props;

        const { countryOptions, addressOptions } = this.props.wirelessPortInRequest;
        const { isRequestOnBehalf, requestOnBehalfData } = this.props.createRequest;
        let isROB = isRequestOnBehalf && (requestOnBehalfData.EmployeeId === '' || requestOnBehalfData.EmployeeId === 0)    
        let showPreferredAddress = wirelessPortInLocationFormA.locationId.toString() === "-1";

        let disable = wirelessPortInLocationFormA.countryCode == ''
            || wirelessPortInLocationFormA.locationId === '' || isROB;
            
        if (showPreferredAddress) {
            disable = disable || wirelessPortInLocationFormA.otherDeliveryAddress == '';
        }

        return (
            <div className="portin-subscription-container">
                <Row className="margin-bottom-20">
                    <div className='use-request-container'>
                        <span onClick={setRequestorAddress} className="requestor-address-link">Use Requestor Address</span>
                    </div>
                    <Col xs={12} md={12} lg={12}>
                        <CustomSearchableSelectWrapper
                            requiredField
                            label={`${this.toLocaleLanguage('country')}`}
                            options={countryOptions}
                            placeholder={this.toLocaleLanguage('select_placeholder')}
                            fieldProp='.countryCode'
                            selected={wirelessPortInLocationFormA.countryCode}
                            onChange={(e) => onCountrySelect('wirelessPortInLocationFormA.countryCode', e)}
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                <Row className="margin-bottom-20">
                    <Col className='requesto-info-container' xs={12} md={12} lg={12}>
                        <CustomSearchableSelectWrapper
                            requiredField             
                            label={`${this.toLocaleLanguage('delivery_address')}`}
                            options={addressOptions}
                            placeholder={this.toLocaleLanguage('select_placeholder')}
                            fieldProp='.locationId'
                            selected={wirelessPortInLocationFormA.locationId}
                            onChange={(e) => this.handleChange('wirelessPortInLocationFormA.locationId', e)}                           
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            maxLength={MAX_LENGTH.limit_500}         
                        />
                        {
                            wirelessPortInLocationFormA.deliveryAddress !== '' &&  !disable &&
                            <div className="delivery-address-label">
                                {wirelessPortInLocationFormA.deliveryAddress}
                            </div>
                        }
                    </Col>
                </Row>
                {showPreferredAddress &&
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <TextArea
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                label={`${this.toLocaleLanguage('preferred_delivery_address')}`}
                                fieldProp='wirelessPortInLocationFormA.otherDeliveryAddress'
                                maxLength={MAX_LENGTH.limit_500}
                                value={wirelessPortInLocationFormA.otherDeliveryAddress} />
                        </Col>
                    </Row>
                }
                <div className="request-button-continer">
                    <div className="bottom-left">
                        <Button
                            label={this.toLocaleLanguage('modal_close_cancel_button')}
                            variant={"light"}
                            action={onClickCancel}
                            type="button"
                        />
                    </div>
                    <div className="bottom-right">
                        {
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('next_button')}
                                    type={"button"}
                                    variant={"primary"}
                                    action={this.handleNextAction}
                                    disabled={disable}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelessPortInRequest, translation, createRequest } = state;
        const { wirelessPortInLocationFormA } = state.form;
        return {
            wirelessPortInRequest
            , wirelessPortInLocationFormA
            , ...translation
             , createRequest
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessPortInActions, createRequestActions),
            dispatch
        )
)(PortInLocationFormA);